import { z } from 'zod';

/** The fixed API envelope: { data, meta, errors } (CLAUDE.md §5.6). */
export const apiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  status: z.number().optional(),
  fields: z.record(z.array(z.string())).optional(),
  context: z.record(z.unknown()).optional(),
  correlationId: z.string().optional(),
});

// The inferred zod type is exactly what callers need; spelling it out by hand
// would be unreadable and would drift from the schema.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- inferred zod type is the contract
export function envelopeSchema<T extends z.ZodTypeAny>(data: T) {
  return z.object({
    data,
    meta: z.record(z.unknown()).default({}),
    errors: z.array(apiErrorSchema).default([]),
  });
}

export type ApiErrorPayload = z.infer<typeof apiErrorSchema>;
